import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { Lock } from "@/api/locks";

export function LockChip({ lockId }: { lockId: number }) {
  const [item, setItem] = useState<Lock | null>(null);
  const items = useAppSelector((state) => state.handbooks.lock);
  const disclosure = useDisclosure();

  useEffect(() => {
    if (lockId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == lockId) || null);
    }
  }, [lockId, items]);

  return (
    <>
      {lockId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {lockId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {lockId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
